export enum MerchantPromoTypeEnum {
   Promo = 1
}
